// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"38":"a2e28f95","136":"37049fce"}[chunkId] + ".js";
};